<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-2">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-with-element-number">
<div class="element-number-block">
<div class="element-number case-upper"></div>
</div>
<div class="title-block">
<h1 class="element-title case-upper">LA’S STUFFED BEEFLESS-PHILLY PORTOBELLO</h1>
</div>
<div class="heading-ornament-block heading-ornament-aspect-wide">
<div class="heading-ornament-size-container">
<img alt="" class="heading-ornament-image" src="images/heading-swash-ornate-screen.png"/>
</div>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-2-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-f"><span class="drop-cap">F</span>rom #1 Bestselling author, La Ammitai</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/stuffed-beefless-philly-portobello---la-ammitai.jpg"/>
</div>
</div>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">• 6-8 large portobello</span> mushrooms</p>
<p class="subsq">• 1 bag Gardein® beefless crumbles</p>
<p class="subsq">• 1 green pepper, chopped</p>
<p class="subsq">• 1 red pepper, chopped</p>
<p class="subsq">• 1 cup sweet onion, chopped</p>
<p class="subsq">• 2 garlic cloves, minced</p>
<p class="subsq">• 1/2 tsp black pepper, divided</p>
<p class="subsq">• ½ tsp sea salt, divided</p>
<p class="subsq">• 2 oz light cream cheese, softened</p>
<p class="subsq">• 2 oz light mayo</p>
<p class="subsq">• 2 tbsp olive oil</p>
<p class="subsq">• 8oz shredded mozzarella &amp; provolone cheese</p>
<p class="subsq">• Fresh parsley</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">Preheat oven</span> to 400 degrees F</p>
<p class="subsq">Rinse Portobello mushrooms with cold water. Remove the stems and scoop out the gills from each of them. Lightly coat the outside with olive oil then sprinkle on salt and pepper the top and sides of each mushroom. Place on a baking sheet and set aside.</p>
<p class="subsq">In a large skillet, heat 1 tbsp. of olive oil on medium-high heat. Add Gardein® crumbles and season with sea salt and black pepper. Sear according to package instructions, stirring frequently. Add red pepper, green pepper, onion, and garlic during the last 4 minutes of cooking. Transfer to a large bowl, and then stir in mayo and cream cheese. Be sure to mix it well! 6</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">Distribute</span> the mixture evenly inside each mushroom cap. Top with mozzarella &amp; provolone cheese. Bake in oven for about 20 minutes or until mushrooms are tender and cheese is completely melted. Let cool for 3 minutes. Plate them and garnish with parsley… AND YOU HAVE NOW BEEN SERVED!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?5ec6ce55